import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";

export default function EditPost() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [caption, setCaption] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPost();
  }, []);

  const fetchPost = async () => {
    try {
      const res = await api.get(`/api/posts/${id}`);
      if (res?.data?.status) {
        setCaption(res.data.data.caption || "");
      }
    } catch (err) {
      console.error("Load post error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      await api.put(`/api/posts/update/${id}`, { caption });
      alert("Post updated successfully");
      navigate("/user/content");
    } catch (err) {
      console.error("Update error", err);
      alert("Update failed");
    }
  };

  if (loading) return <p className="panel-loading">Loading...</p>;

  return (
    <div className="panel-container">
      <h2 className="section-title">Edit Post</h2>

      <div className="form-card">
        <textarea
          className="form-textarea"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          placeholder="Write caption..."
        />

        <button className="primary-btn" onClick={handleUpdate}>
          Update Post
        </button>
      </div>
    </div>
  );
}
